export const LocalStoreLocaleKey = 'OwaLocale';
